import { createVanIconComponent } from "./van"

const VipCard = createVanIconComponent("vip-card")
export default VipCard
